import request from '@/utils/request'


// 查询任务时间设置列表
export function listTaskTimeConfig(query) {
  return request({
    url: '/task/task/time/config/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询任务时间设置分页
export function pageTaskTimeConfig(query) {
  return request({
    url: '/task/task/time/config/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询任务时间设置详细
export function getTaskTimeConfig(data) {
  return request({
    url: '/task/task/time/config/detail',
    method: 'get',
    params: data
  })
}

// 新增任务时间设置
export function addTaskTimeConfig(data) {
  return request({
    url: '/task/task/time/config/add',
    method: 'post',
    data: data
  })
}

// 修改任务时间设置
export function updateTaskTimeConfig(data) {
  return request({
    url: '/task/task/time/config/edit',
    method: 'post',
    data: data
  })
}

// 删除任务时间设置
export function delTaskTimeConfig(data) {
  return request({
    url: '/task/task/time/config/delete',
    method: 'post',
    data: data
  })
}
